import React from 'react';
import _ from 'lodash';

import Avatar from 'components/Avatar';

import './styles.css';

const TeamInformation = ({
  team: {avatarUrl, name, members, inactivityLogoutTimer}
}) => (
  <div className="TeamInformation">
    <Avatar url={avatarUrl} initials="" />
    <div className="text">
      <div className="name">{name}</div>
      {!_.isEmpty(members) && (
        <div className="membersCount">{members.length} members</div>
      )}
      {!_.isNull(inactivityLogoutTimer) && (
        <div className="inactivityLogout">
          Inactivity Logout: After {inactivityLogoutTimer} minutes
        </div>
      )}
    </div>
  </div>
);

export default TeamInformation;
